import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginPage from "@Shared/components/general/login-page.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { INIT_SESSION, LOGIN, TO_ENABLE_MFA_SEND_CODE, VALIDATE_OR_ENABLE_MFA, MFA_REMIND_ME_LATER, RESEND_MFA_CODE } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions, mapGetters, mapState } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { SHOULD_SHOW_PAYMENT_FAILED_BANNER, SHOULD_SHOW_WELCOME_PLAN_BANNER } from "@Broker/@Modules/main/store/account/account-getters";
import PendoUtils from "@Shared/@Utils/pendo";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LoginContainer",
  title() {
    return this.$t("sidebar.sections.login");
  },
  components: {
    LoginPage
  },
  props: {
    redirectPath: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      loading: false,
      loadingStatus: true,
      sendingMfaCode: false,
      isMfaRequiredAndNotEnabled: false,
      mfaCodeDelivered: true,
      validateMfaCode: false,
      accessToken: null,
      codeDestination: null,
      mfaEmail: null,
      password: null,
      validateMfaRequest: {
        token: null,
        session: null,
        userId: null,
        mfaMethod: "sms",
        mfaValue: null
      },
      sessionResult: null,
      mfaPreferences: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["token"])), mapFields("AccountStore", ["showWelcomeModal", "showPaymentFailureModal"])), mapGetters("AccountStore", [SHOULD_SHOW_WELCOME_PLAN_BANNER, SHOULD_SHOW_PAYMENT_FAILED_BANNER])),
  beforeMount() {
    Amplitude.logEvent("Login - visited", {
      page: "login"
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [LOGIN, INIT_SESSION, TO_ENABLE_MFA_SEND_CODE, VALIDATE_OR_ENABLE_MFA, MFA_REMIND_ME_LATER, RESEND_MFA_CODE])), {}, {
    getSanitizedPath() {
      return RichTextEditor.sanitizeHtml(window.location.pathname).replace("/", "").replace("#", "");
    },
    showErrorToast(key) {
      this.loading = false;
      this.loadingStatus = false;
      showToast("error", key);
    },
    handleExistingSessionLoginAttempt(emailSend) {
      const currentEmail = this.$auth.session.get().userDetails.email;
      if (currentEmail === emailSend) return true;
      this.$auth.session.end();
      return false;
    },
    async handleLogin({
      email,
      password
    }) {
      if (this.token && this.handleExistingSessionLoginAttempt(email)) {
        window.location.reload();
        return;
      }
      this.loading = true;
      try {
        var _sessionResult$challe, _sessionResult$accoun, _sessionResult$accoun2, _sessionResult$mfa;
        const deviceConfig = (() => {
          try {
            const config = JSON.parse(localStorage.getItem("deviceInfo"));
            const deviceInfoEmail = config["email"];
            if (deviceInfoEmail === email.toLowerCase()) {
              return config["deviceInfo"];
            } else {
              localStorage.removeItem("deviceInfo");
              return null;
            }
          } catch (_unused) {
            return null;
          }
        })();
        const path = this.getSanitizedPath();
        const sessionResult = await this.LOGIN({
          email,
          password,
          subdomain: path,
          deviceConfig: deviceConfig && deviceConfig["deviceKey"] ? deviceConfig : null
        });
        const challenge = sessionResult == null ? void 0 : (_sessionResult$challe = sessionResult.challenge) == null ? void 0 : _sessionResult$challe.challengeName;
        const hasToken = sessionResult == null ? void 0 : sessionResult.token;
        this.validateMfaCode = !!(challenge && !hasToken);
        if (sessionResult.deviceInfo) {
          localStorage.setItem("deviceInfo", _JSON$stringify({
            isTrustedDevice: false,
            email: sessionResult.userDetails.email.toLowerCase(),
            deviceInfo: sessionResult.deviceInfo
          }));
        }
        if (this.validateMfaCode) {
          var _sessionResult$challe2, _sessionResult$challe3, _sessionResult$challe4;
          this.mfaEmail = email;
          this.password = password;
          this.codeDestination = this.$t("account.mfaCodeSentText", {
            destination: (sessionResult == null ? void 0 : (_sessionResult$challe2 = sessionResult.challenge) == null ? void 0 : (_sessionResult$challe3 = _sessionResult$challe2.challengeParameter) == null ? void 0 : (_sessionResult$challe4 = _sessionResult$challe3.codeDestination) == null ? void 0 : _sessionResult$challe4.replace("*******", "XXXXXXX")) || ""
          });
          _Object$assign(this.validateMfaRequest, {
            session: sessionResult.session,
            userId: sessionResult.username,
            mfaMethod: challenge
          });
          return;
        }
        if (sessionResult.mfa) {
          this.mfaEmail = email;
          this.password = password;
          this.isMfaRequiredAndNotEnabled = sessionResult.mfa.mfaRequiredByBrokerage && !sessionResult.mfa.isUserMfaEnabled;
          this.sessionResult = sessionResult;
        }
        if (((_sessionResult$accoun = sessionResult.accountDetails) == null ? void 0 : _sessionResult$accoun.accountType) === "client") throw new Error("User is not authorized");
        this.accessToken = sessionResult.token;
        this.mfaPreferences = ((_sessionResult$accoun2 = sessionResult.accountPreferences) == null ? void 0 : _sessionResult$accoun2.mfaPreferences) || {};
        _Object$assign(this.validateMfaRequest, {
          session: sessionResult.session,
          userId: sessionResult.userIdForSrp,
          mfaMethod: challenge
        });
        if (hasToken && (!this.isMfaRequiredAndNotEnabled || !((_sessionResult$mfa = sessionResult.mfa) != null && _sessionResult$mfa.mfaRequiredByBrokerage))) {
          var _sessionResult$accoun3;
          this.postLoginProcess(sessionResult);
          this.redirect((_sessionResult$accoun3 = sessionResult.accountDetails) == null ? void 0 : _sessionResult$accoun3.accountSubdomain);
        }
      } catch (error) {
        console.error("Error in login process", error);
        this.showErrorToast("somethingWentWrongTryAgainLater");
      } finally {
        this.loading = false;
      }
    },
    postLoginProcess(sessionResult) {
      if (sessionResult.pendingEmailVerification) {
        showToast("info", "WelcomeAndVerifyEmail");
        this.$router.replace({
          name: "registration-verify"
        });
        return;
      }
      this.INIT_SESSION(sessionResult);
      PendoUtils.startSession(sessionResult);
      Amplitude.startSession(sessionResult);
      this.handleFirstTimeModals();
    },
    async validateMfaAndSignIn({
      mfaCode,
      isTrustedDevice
    }) {
      this.sendingMfaCode = true;
      const path = RichTextEditor.sanitizeHtml(window.location.pathname).replace("/", "").replace("#", "");
      const payload = _objectSpread(_objectSpread({}, this.validateMfaRequest), {}, {
        mfaCode,
        token: this.accessToken,
        isTrustedDevice,
        subdomain: path
      });
      try {
        const sessionResult = await this.VALIDATE_OR_ENABLE_MFA(payload);
        if (sessionResult.deviceInfo) {
          localStorage.setItem("deviceInfo", _JSON$stringify({
            isTrustedDevice: isTrustedDevice,
            email: sessionResult.userDetails.email.toLowerCase(),
            deviceInfo: sessionResult.deviceInfo
          }));
        }
        this.mfaCodeDelivered = true;
        this.sendingMfaCode = false;

        // Use nextTick to ensure UI updates before heavy operations
        this.postLoginProcess(sessionResult);
        this.$nextTick(() => {
          var _sessionResult$accoun4;
          this.redirect((_sessionResult$accoun4 = sessionResult.accountDetails) == null ? void 0 : _sessionResult$accoun4.accountSubdomain);
        });
      } catch (error) {
        this.sendingMfaCode = false;
        this.mfaCodeDelivered = false;
        console.error("MFA validation error:", error);
        showToast("error", "failedToValidateMfaAndSignIn");
      }
    },
    async updatePreferredMfaSendCode({
      mfaValue,
      method
    }) {
      this.sendingMfaCode = true;
      this.validateMfaRequest.mfaMethod = method;
      this.validateMfaRequest.mfaValue = mfaValue;
      try {
        const mfaResult = await this.TO_ENABLE_MFA_SEND_CODE({
          mfaMethod: method,
          mfaValue,
          token: this.accessToken,
          username: this.validateMfaRequest.userId
        });
        this.sendingMfaCode = false;
        if (!mfaResult) {
          this.mfaCodeDelivered = false;
          return;
        }
        let valueToShow = "";
        if (method === "email") {
          // Mask email: keep first 2 chars, domain start/end, mask rest
          valueToShow = mfaValue.replace(/^(.{2}).*(@.{2}).*(\..*)$/, (_, start, domainStart, domainEnd) => `${start}XXXX${domainStart}XXXX${domainEnd}`);
        } else {
          // Mask phone: keep last 2 digits, mask rest
          const digits = mfaValue.replace(/\D/g, "");
          valueToShow = digits.length >= 2 ? `XXXXXX${_sliceInstanceProperty(digits).call(digits, -2)}` : "XXXXXX";
        }
        this.codeDestination = this.$t("account.mfaCodeSentText", {
          destination: valueToShow
        });
        this.mfaCodeDelivered = true;
        this.validateMfaCode = true;
      } catch (error) {
        console.error("Error enabling MFA:", error);
        this.sendingMfaCode = false;
        this.mfaCodeDelivered = false;
        showToast("error", "failedToEnableMfa");
      }
    },
    redirect(accountSubdomain) {
      const path = this.getSanitizedPath();
      accountSubdomain && path !== accountSubdomain ? window.location.href = `/${accountSubdomain}#${this.redirectPath}` : this.$router.push(this.redirectPath);
    },
    async snoozeMfaSetup() {
      if (this.mfaPreferences.mfaSnoozeRemaining <= 0) return;
      this.loading = true;
      this.loadingStatus = true;
      try {
        var _this$sessionResult$a;
        this.mfaPreferences.mfaSnoozeRemaining = _parseInt(this.mfaPreferences.mfaSnoozeRemaining) - 1;
        await this.MFA_REMIND_ME_LATER({
          token: this.accessToken,
          mfaPreferences: this.mfaPreferences,
          username: this.validateMfaRequest.userId
        });
        this.postLoginProcess(this.sessionResult);
        this.redirect((_this$sessionResult$a = this.sessionResult.accountDetails) == null ? void 0 : _this$sessionResult$a.accountSubdomain);
      } catch (error) {
        console.error("Error snoozing MFA setup:", error);
        showToast("error", "failedToSnoozeMfaSetup");
      } finally {
        this.loading = false;
        this.loadingStatus = false;
      }
    },
    async reSendCode() {
      try {
        if (this.isMfaRequiredAndNotEnabled === true) {
          const result = await this.TO_ENABLE_MFA_SEND_CODE({
            mfaMethod: this.validateMfaRequest.mfaMethod,
            mfaValue: this.validateMfaRequest.mfaValue,
            token: this.accessToken,
            username: this.validateMfaRequest.userId
          });
          if (result) {
            showToast("success", "codeResentSuccessfully");
          }
        } else if (this.validateMfaCode) {
          await this.handleLogin({
            email: this.mfaEmail,
            password: this.password
          });
          showToast("success", "codeResentSuccessfully");
        } else {
          showToast("error", "unableToResendCode");
        }
      } catch (error) {
        console.error("Error resending code:", error);
        showToast("error", "unableToResendCode");
      }
    },
    handleFirstTimeModals() {
      this.showPaymentFailureModal = this.SHOULD_SHOW_PAYMENT_FAILED_BANNER;
      if (!this.showPaymentFailureModal) {
        this.showWelcomeModal = this.SHOULD_SHOW_WELCOME_PLAN_BANNER;
      }
    }
  })
});